import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getGuestLectures = async () => {
  const response = await axios.get(`${base_url}guestlecture`, config);

  return response.data;
};
const getGuestLecturesmanu = async () => {
  const response = await axios.get(`${base_url}guestlecture`, config);

  return response.data;
};
const deleteAGuestLectures = async (id) => {
  const response = await axios.delete(`${base_url}guestlecture/${id}`, config);
  return response.data;
};
const getAGuestLectures = async (id) => {
  const response = await axios.get(`${base_url}guestlecture/${id}`);
  return response.data;
};
const updateAGuestLectures = async (enq) => {
  const response = await axios.put(
    `${base_url}guestlecture/${enq.id}`,
    { status: enq.enqData },
    config
  );
  return response.data;
};

//new endpoint

const guestlectureService = {
  getGuestLectures,
  deleteAGuestLectures,
  getAGuestLectures,
  updateAGuestLectures,
  getGuestLecturesmanu,
};

export default guestlectureService;
